import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Spinner(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <g transform="rotate(0 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.9s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(30 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.8s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(60 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.75s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(90 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.666s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(120 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.583s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(150 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(180 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.416s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(210 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.333s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(240 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.25s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(270 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.166s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(300 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="1s"
            begin="-0.083s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(330 12 12)">
        <rect x="11" y="0" width="2" height="6" fill="currentColor">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" />
        </rect>
      </g>{' '}
    </IconWrapper>
  );
}
